module.exports = __webpack_public_path__ + "img/logo-full-rounded.cda3690.png";